import { Chip } from "@mui/material";

import { CustomFieldStatus } from "@/shared/domain/customFields";

import {
  customFieldStatusColor,
  customFieldStatusLabel,
} from "./customFieldPresentation";

interface CustomFieldStatusChipProps {
  status: CustomFieldStatus;
}

export function CustomFieldStatusChip({ status }: CustomFieldStatusChipProps) {
  return (
    <Chip
      color={customFieldStatusColor(status)}
      label={customFieldStatusLabel(status)}
      size="small"
      variant="outlined"
    />
  );
}
